
type PageParams = string | null

export const getUrlSearchParam = (paramName: string): PageParams => {
  if (typeof document === 'undefined') {
    // Prevent server side breaks.
    return null
  }

  const searchParams = new URLSearchParams(document.location.search)

  return searchParams.get(paramName)
}

export const getLastUrlFragment = (defaultPathname: string): string => {
  let currentPath = typeof window === 'object' ? window.location.pathname : defaultPathname

  if (currentPath.lastIndexOf('/') === currentPath.length - 1) {
    // Remove last "/" if any.
    currentPath = currentPath.slice(0, -1)
  }

  return currentPath.substring(currentPath.lastIndexOf('/') + 1)
}

export const getRootPath = (questionData: QuestionData[], defaultPathname: string): string => {
  const pageKeys: string[] = questionData.map(question => question.key)

  const lastUrlFragment = getLastUrlFragment(defaultPathname)
  const hasQuestionKey = pageKeys.includes(lastUrlFragment)

  let currentPath = window.location.pathname
  if (currentPath.lastIndexOf('/') === currentPath.length - 1) {
    // Remove last "/" if any.
    currentPath = currentPath.slice(0, -1)
  }

  if (hasQuestionKey) {
    return currentPath.slice(0, currentPath.lastIndexOf(lastUrlFragment) - 1)
  } else {
    return currentPath
  }
}

export const getKeyFromPath = (questionData: QuestionData[], defaultPathname: string): string => {
  const pageKeys: string[] = questionData.map(question => question.key)

  const lastUrlFragment = getLastUrlFragment(defaultPathname)
  const hasQuestionKey = pageKeys.includes(lastUrlFragment)

  return hasQuestionKey ? lastUrlFragment : pageKeys[0]
}

export const loadNextQuestionByKey = ({
  key,
  index,
  questionData,
  defaultPathname,
}: {
  key: string
  index: number
  questionData: QuestionData[]
  defaultPathname: string
}): void => {
  const root = getRootPath(questionData, defaultPathname)
  history.pushState({ page: index }, key, `${root}/${key}`)
}
